import { render, staticRenderFns } from "./PresupuestoHistoricoV4.vue?vue&type=template&id=1da729bd&scoped=true"
import script from "./PresupuestoHistoricoV4.vue?vue&type=script&lang=js"
export * from "./PresupuestoHistoricoV4.vue?vue&type=script&lang=js"
import style0 from "./PresupuestoHistoricoV4.vue?vue&type=style&index=0&id=1da729bd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1da729bd",
  null
  
)

export default component.exports